exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.Statuses_message_3dPb,\n.Statuses_error_16Lo {\n  margin-top: 24px;\n\n  max-width: none;\n\n  text-align: left;\n}\n", ""]);

// exports
exports.locals = {
	"message": "Statuses_message_3dPb",
	"error": "Statuses_error_16Lo"
};